import React from 'react';
import t from '@guestyci/localize/t.macro';
import { Text, Stack } from '@guestyci/arc';
import { ExternalLink } from '@guestyci/icons/system';

const HostsLink = ({ hostsLoginUrl = 'https://app.guestyforhosts.com/' }) => {
  return (
    <Stack direction="row" spacing={1} align="center">
      <Text size="sm" className="gst-text-muted-foreground">
        {t('Guesty for Hosts User?')}
      </Text>
      <Text size="sm" className="gst-text-primary gst-font-medium">
        <a href={hostsLoginUrl} target="_blank" rel="noopener noreferrer" className="gst-inline-flex gst-items-center gst-gap-1 gst-text-inherit">
          {t('Go to Guesty for Hosts')}
          <ExternalLink className="gst-h-3 gst-w-3" />
        </a>
      </Text>
    </Stack>
  );
};

export default HostsLink;
